module.exports = __webpack_public_path__ + "img/vertical_7_4_8017.7cfe92d4.png";